export const footerSubtitle='Codex 安装指南、Skills 技能与 AI 创作的起点。';
export const footerCompany='深圳市诺普德科技有限公司';
export const icp={label:'粤ICP备2024272000号',href:'https://beian.miit.gov.cn/'} as const;
export const footerLinks=[{label:'安装指南',href:'/download'},{label:'使用指南',href:'/tutorial'},{label:'Skills 技能',href:'/skills'},{label:'帮助中心',href:'/help'},{label:'常见问题',href:'/help#faq'},{label:'API 开放平台',href:'/api-platform'},{label:'代理中心（预览）',href:'/agent/overview'}] as const;
